var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14899 0C-0.60359 0 -0.60359 3.3324 2.14899 3.3324H35.9604C38.7156 3.3324 38.7156 0 35.9604 0H2.14899ZM36.0176 13.3338H2.14639C-0.715462 13.2435 -0.715462 16.7985 2.14639 16.6662H35.9578C38.7676 16.7544 38.8223 13.3338 36.015 13.3338H36.0176ZM2.14639 26.6676C-0.606191 26.6676 -0.606191 30 2.14639 30H35.9578C38.713 30 38.713 26.6676 35.9578 26.6676H2.14639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.79b13201a96dda66fd1f939daebc113a.svg";
export { ForwardRef as ReactComponent };